import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { ResourceLinks } from "../../../../constants";
import { useSelector } from "../../../../store";

export default function WebMultipleTextInputsCalendar({ question, onAnswer = () => {} }) {
    const questionData = question;
    const learnerState = useSelector((state) => state.learner || {});
    const data = learnerState?.details?.testLevel === "vfh" ? questionData?.vfh : questionData?.acsf4;
    const imagesResources = ResourceLinks.llnQuizImage;

    const weekHeader = data.weekHeader;
    // this will know if 1st day of the month not fall in monday
    // this will start from 0 since we wil add to the loop
    const offset = data.daysData.offset;
    const numberOfDays = data.daysData.numberOfDays;
    let currentDay = 0;

    const [answer, setAnswer] = useState(data.initialAnswer);

    // every time question change we will set to reset needed to reset
    useEffect(() => {
        setAnswer(data.initialAnswer);
    }, [question,
        data.initialAnswer,
    ]);

    useEffect(() => {

        const answerKeys = Object.keys(answer);

        let canProceed = false;
        answerKeys.map((keys) => {
            if (answer[keys] !== "") {
                canProceed = true;
            }
            return null;
        });

        onAnswer({
            canProceed,
            answer: answer,
        });

    },[answer, onAnswer]); // asnwer

    const handleChangeInput = (day, event) => {
        let ans = {...answer};
        if (event.target.value !== "") { // meaning we will update the object
            ans = {
                ...ans,
                [day]: event.target.value.trim(),
            };

            setAnswer(ans);

        } else {

            ans = {
                ...ans,
                [day]: "",
            };

            setAnswer(ans);
        }

        const answerKeys = Object.keys(ans);

        let canProceed = false;
        answerKeys.map((keys) => {
            if (typeof ans[keys] == "object") {
                canProceed = true;
            }
            return null;
        });

        onAnswer({
            canProceed,
            answer: ans,
        });
    }

    return (
        <Box sx={{

        }}
        >
            <Box component="img" src={`${imagesResources}${data.image}`} alt="Img"/>
            <Box sx={{
                display: "flex",
                justifyContent: "space-around",
                fontWeight: "bold",
                marginBottom: "10px",
                textAlign: "center"
            }}>
                {weekHeader.map((day, index) => {
                    return (
                        <span key={index} style={day.style}>{day.value}</span>
                    )
                })}
            </Box>

            <Box sx={{
                display: "grid",
                gridTemplateColumns: "repeat(7, 120px)",
                gridTemplateRows: "repeat(5, 60px)",
                padding: "5px",
                width: "880px",
                textAlign: "left",
            }}>
                {[...Array(numberOfDays + offset)].map((_, index) => {
                    const isShow = (index + 1 > offset);
                    if (isShow) {
                        currentDay++;
                    }

                    return <React.Fragment key={index}>
                        {(isShow) ?
                            <Box
                                sx={{
                                    display: "inline-block",
                                    border: "2px solid rgb(19, 66, 99)",
                                    backgroundColor: "rgb(230, 238, 240)",
                                    width: "120px",
                                    height: "60px",
                                    textAlign: "left",
                                    fontWeight: "bold",
                                }}
                            >{currentDay}
                                <Box sx={{
                                    position: "relative",
                                    textAlign: "left",
                                    fontWeight: "bold",
                                }}>
                                    <input 
                                        style={{
                                            width: "100px",
                                            height: "30px",
                                            padding: "2px",
                                            marginLeft: "10px",
                                            boxSizing: "border-box",
                                            outline: "none",
                                            border: "none",
                                            borderBottom: "2px solid #888888",
                                            fontSize: "1.5em",
                                            textAlign: "left",
                                            "& .MuiInputUnderline:after": {
                                                borderBottom:
                                                    "2px solid #00b0f0",
                                            },
                                        }}
                                        onChange={(event) => handleChangeInput(index - offset + 1, event) }
                                    />
                                </Box>
                            </Box>
                            : <Box
                                sx={{
                                    display: "inline-block",
                                    width: "120px",
                                    height: "60px",
                                    textAlign: "left",
                                    fontWeight: "bold",
                                }}
                            >
                                <Box sx={{
                                    position: "relative",
                                    textAlign: "left",
                                    fontWeight: "bold",
                                }}>
                                    
                                </Box>
                            </Box>
                        }
                    </React.Fragment>
                })}
            </Box>
        </Box>
    );
};
